/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GeoCoordinatesForRegionRequest {
    getFixupPrototypeFunction() { return GeoCoordinatesForRegionRequest.fixupPrototype; }

    static newInstance(model: Partial<GeoCoordinatesForRegionRequest>): GeoCoordinatesForRegionRequest {
        let obj = Object.assign(new GeoCoordinatesForRegionRequest(), model);
        GeoCoordinatesForRegionRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GeoCoordinatesForRegionRequest>): GeoCoordinatesForRegionRequest {
        if (!model) return null;
        return GeoCoordinatesForRegionRequest.newInstance(<GeoCoordinatesForRegionRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GeoCoordinatesForRegionRequest) {
        if (!obj) return;

        models.GeoCoordinatesForRegionRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GeoCoordinatesForRegionRequest): boolean {
        Object.setPrototypeOf(obj, GeoCoordinatesForRegionRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    regions: Array<string>;

}
